module.exports = Symbol.iterator

// typeof Symbol !== 'undefined'
//   ? Symbol.iterator
//   : '@@iterator'
